import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgYoutube = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF5151"
      d="M19.99 8S9.362 8 6.695 8.699c-1.428.403-2.604 1.589-3.003 3.05C3 14.44 3 20.011 3 20.011s0 5.592.693 8.24a4.35 4.35 0 0 0 3.003 3.029C9.384 32 19.99 32 19.99 32s10.647 0 13.314-.699a4.24 4.24 0 0 0 2.982-3.029c.714-2.67.714-8.24.714-8.24s.02-5.593-.714-8.283a4.22 4.22 0 0 0-2.982-3.008C30.637 8 19.989 8 19.989 8m-3.382 6.863 8.842 5.148-8.842 5.126z"
    />
    <path
      fill="#00215B"
      d="M18.99 29.51v1c-.11 0-.314 0-.6-.002a216 216 0 0 1-6.367-.128c-3.13-.118-5.384-.304-6.463-.587-1.601-.452-2.905-1.774-3.351-3.407-.262-1.015-.443-2.461-.562-4.212A68 68 0 0 1 1.5 18h1a67.833 67.833 0 0 0 .018 1.246c.023.949.064 1.921.127 2.86.114 1.694.29 3.09.53 4.024.352 1.288 1.394 2.344 2.648 2.698.97.254 3.19.438 6.238.552a194 194 0 0 0 6.334.129zm-2.633-16.215.503-.864 9.585 5.58-5.165 2.995-.502-.865 3.676-2.131z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgYoutube);

export default ForwardRef;
